import * as React from "react"

const matchMedia = globalThis.matchMedia || (() => ({ matches: false }))

export function useMedia(query: string): boolean {
  const mql = React.useMemo(() => matchMedia(query), [query])
  const [matches, setMatches] = React.useState(mql.matches)

  React.useEffect(() => {
    mql.onchange = () => setMatches(mql.matches)

    return () => {
      mql.onchange = null
    }
  }, [mql])

  return matches
}
